export const Namespace = {
  auth: 'auth',
  common: 'common',
  main: 'main',
  user: 'user',
} as const;

export const Namespaces = Object.values(Namespace);
